import React from "react";
import RentalInfoForm from "../RentalInfoForm";

class ActiveRentalInfo extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            backUrl: '/system/' + this.props.match.params.systemId + '/rentals/active',
        };
    }

    render() {
        return (
            <RentalInfoForm backUrl={this.state.backUrl}
                            history={this.props.history}
                            location={this.props.location}
                            match={this.props.match}/>
        )
    }
}

export default ActiveRentalInfo;